"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmergencyDisclaimer;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _Banners = require("../../Banners");
var _Markdown = _interopRequireDefault(require("../../Markdown"));
/*eslint-disable react/no-danger*/

function EmergencyDisclaimer(_ref) {
  let {
    config,
    onClose,
    onClick
  } = _ref;
  const {
    enabled: showMd,
    markdown
  } = config.emergency_disclaimer_md || {};
  const {
    enabled: showText,
    text
  } = config.emergency_disclaimer || {};
  return showMd ? /*#__PURE__*/_react.default.createElement(_styles.Container, null, /*#__PURE__*/_react.default.createElement(_Banners.EmergencyBanner, {
    onClose: onClose
  }, /*#__PURE__*/_react.default.createElement(_Markdown.default, {
    markdown: markdown,
    onClick: onClick
  }))) : showText ? /*#__PURE__*/_react.default.createElement(_styles.Container, null, /*#__PURE__*/_react.default.createElement(_Banners.EmergencyBanner, null, text)) : null;
}
EmergencyDisclaimer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EmergencyDisclaimer"
};